import { gql } from "@apollo/client";

export const GET_PROVEEDORES_SAP = gql`
    query GetProveedoresSap(
        $skip: Int
        $take: Int
        $where: ProveedorModelFilterInput
        $order: [ProveedorModelSortInput!]
    ) {
        proveedoresSAPPaginated(
            skip: $skip
            take: $take
            where: $where
            order: $order
        ) {
            items{
                cod_Proveedor
                nombre
                cUIT
                localidad
            }
                totalCount
        }
    }
`;

export const adaptProveedor = (proveedor) => {
  return {
    cod_Proveedor: proveedor.cod_Proveedor,
    nombre: proveedor.nombre.toUpperCase(),
    cuit: proveedor.cUIT,
    localidad: proveedor.localidad.toUpperCase()
  };
};

export const adaptProveedoresSapArray = (proveedores) => {
  return structuredClone(proveedores)?.
  map((proveedor) => adaptProveedor(proveedor));
};